import { render, staticRenderFns } from "./SellIndextion.vue?vue&type=template&id=073b26d6&scoped=true"
import script from "./SellIndextion.vue?vue&type=script&lang=js"
export * from "./SellIndextion.vue?vue&type=script&lang=js"
import style0 from "./SellIndextion.vue?vue&type=style&index=0&id=073b26d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b26d6",
  null
  
)

export default component.exports